import { createFileRoute } from "@tanstack/react-router";
import {
  checkPermissionsInLoader,
  returnPermissionsInLoader,
} from "@dmca/frontend/hooks";
import PowerPageComponent from "./smartcell/power/-PowerPageComponent";

export const Route = createFileRoute("/_authed/power")({
  component: PowerPageComponent,
  loader: async ({ context }) => {
    await checkPermissionsInLoader("SmartCell::ViewSmartCellOverview", context);
    const { trpcQcProxy: trpc, qc } = context;

    const [plants, cells] = await Promise.all([
      qc.ensureQueryData(trpc.plant.getAll.queryOptions()),
      qc.ensureQueryData(trpc.cell.getAll.queryOptions()),
    ]);

    const allCellIds = cells.map((cell) => cell.cellId);

    const hasPulseMeterPermission = await returnPermissionsInLoader(
      "PulseMeter::ViewFeature",
      context
    );

    if (hasPulseMeterPermission) {
      void qc.prefetchQuery(
        trpc.pulseMeter.getMultiple.queryOptions({ byLocationIds: allCellIds })
      );
    }

    const hasGHGPermission = await returnPermissionsInLoader(
      "GHG::ViewGHG",
      context
    );

    // Warm cache in the background - do not block route render. Await these
    // under CI load delayed PageHeader past Playwright readiness timeouts.
    if (hasGHGPermission) {
      void qc.prefetchQuery(trpc.ghg.getResources.queryOptions());
      void qc.prefetchQuery(trpc.ghg.findLastReport.queryOptions());
    }

    return { plants, cells, hasGHGPermission, hasPulseMeterPermission };
  },
  head: () => ({
    meta: [{ title: "Power Usage | DNA Dashboard" }],
  }),
});
